import React from 'react'
import { Link } from 'react-router-dom'

const Footer: React.FC = () => {
  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>Christ the King Church</h3>
              <p className="anniversary-text">Celebrating 50 Years of Faith and Fellowship</p>
              <p>Founded in 1975, Christ the King Church has been a beacon of hope and love in our community for five decades.</p>
            </div>
            
            <div className="footer-section">
              <h4>Quick Links</h4>
              <ul>
                <li><Link to="/about-us">About Us</Link></li>
                <li><Link to="/history">Our History</Link></li>
                <li><Link to="/schedules">Service Times</Link></li>
                <li><Link to="/contact-us">Contact Us</Link></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h4>Community</h4>
              <ul>
                <li><Link to="/community-groups/sunday-school">Sunday School</Link></li>
                <li><Link to="/community-groups/youth-fellowship">Youth Fellowship</Link></li>
                <li><Link to="/community-groups/womens-fellowship">Women's Fellowship</Link></li>
                <li><Link to="/community-groups/choir">Choir</Link></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h4>Contact Info</h4>
              <div className="contact-info">
                <p><strong>Address:</strong><br />#321, 6th Main Road, <span>Bahubali Nagar, Jalahalli, </span> Bengaluru, Karnataka 560013</p>
                <p><strong>Email:</strong><br />csictkc.jalahalli@gmail.com</p>
              </div>
            </div>
          </div>
          
          <div className="footer-bottom">
            <div className="footer-bottom-content">
              <p>&copy; 2025 Christ the King Church. All rights reserved.</p>
              <p className="anniversary-footer">1975 - 2025 | Celebrating 50 Years</p>
            </div>
          </div>
        </div>
      </footer>

      <style>{`
        .footer {
          background-color: #1e2948;
          color: #d1d5db;
          margin-top: auto;
          font-family: 'Inter', sans-serif;
        }

        .footer-content {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 2rem;
          padding: 3.5rem 0 2rem;
        }

        .footer-section h3 {
          color: #D4AF37;
          font-size: 1.15rem;
          margin-bottom: 1rem;
          font-family: 'Playfair Display', serif;
        }

        .footer-section h4 {
          color: #ffffff;
          font-size: 1rem;
          margin-bottom: 1rem;
          font-weight: 600;
        }

        .anniversary-text {
          color: #ffffff;
          font-weight: 400;
          margin-bottom: 1rem;
          font-size: 0.95rem;
        }

        .footer-section p {
          font-size: 0.85rem;
          line-height: 1.6;
          color: #d1d5db;
          text-align: left;
        }

        .footer-section ul {
          list-style: none;
          padding: 0;
        }

        .footer-section ul li {
          margin-bottom: 0.5rem;
        }

        .footer-section ul li a {
          color: #d1d5db;
          text-decoration: none;
          font-size: 0.85rem;
          transition: color 0.3s ease;
        }

        .footer-section ul li a:hover {
          color: #D4AF37;
        }

        .contact-info p {
          font-size: 0.85rem;
          margin-bottom: 1rem;
          line-height: 1.6;
        }
        
        .contact-info strong {
          color: #ffffff;
          font-weight: 500;
          display: none;
        }

        .footer-bottom {
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          padding: 1.5rem 0;
          font-size: 0.8rem;
          color: #9ba3af;
        }

        .footer-bottom-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 1rem;
        }
        
        .footer-bottom-content p {
          margin: 0;
          text-align: left;
        }

        .anniversary-footer {
          color: #9ba3af;
          font-weight: 400;
        }

        @media (max-width: 768px) {
          .footer-content {
            grid-template-columns: 1fr;
            gap: 2.5rem;
            padding: 2.5rem 0 1.5rem;
          }
          
          .footer-bottom-content {
            flex-direction: column;
            text-align: center;
          }
        }
      `}</style>
    </>
  )
}

export default Footer